import {Product} from "./product";

export class Collection {
    public id: string;
    public type: string;
    public name: string;
    public display_name: string;
    public mobile_banner_key: string;
    public state: string;
    public publish_from: Date;
    public publish_till: Date;
    public outfits: Outfit[];
    public editorial_layout: EditorialLayout;

    constructor(values: any) {
        this.id = values.id;
        this.type = values.type;
        this.name = values.name;
        this.display_name = values.display_name;
        this.mobile_banner_key = values.mobile_banner_key;
        this.state = values.state;
        this.publish_from = new Date(values.publish_from);
        this.publish_till = new Date(values.publish_till);
        this.outfits = values.outfits?.map(o => new Outfit(o));
        this.editorial_layout = values.editorial_layout ? values.editorial_layout : EditorialLayout.SINGLE_PORTRAIT;
    }

    extractProducts(): Product[] {
        const products: Product[] = [];
        for (const outfit of this.outfits) {
            outfit.products?.forEach(outfitProduct => {
                products.push(outfitProduct.product);
            })
        }
        return products;
    }
}

export class Outfit {
    public id: string;
    public name: string;
    public position: string;
    public state: string;
    public image_key: string;
    public image_orientation: string;
    public products: OutfitProduct[];
    public descriptions: Record<string, string>;

    constructor(values: any) {
        this.id = values.id;
        this.name = values.name;
        this.position = values.position;
        this.state = values.state;
        this.image_key = values.image_key;
        this.image_orientation = values.image_orientation;
        this.products = values.products?.map(op => new OutfitProduct(op));
        this.descriptions = values.descriptions ? values.descriptions : {};
    }
}

export enum EditorialLayout {
    SINGLE_PORTRAIT = "SINGLE_PORTRAIT",
    PORTRAIT_ONLY = "PORTRAIT_ONLY"
}

export class OutfitProduct {
    public product_id: string;
    public variant_id: string;
    public product: Product;

    constructor(values) {
        this.product_id = values.product_id;
        this.variant_id = values.variant_id;
        this.product = new Product(values.product);
    }
}